// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__y3Dig","icon":"tabs_icon__l3EKD","Active-btn":"tabs_Active-btn__cKODh","overlay":"tabs_overlay__k7Dro","showTabs":"tabs_showTabs__HOOI9"};